module.exports = __webpack_public_path__ + "img/form-bg.cede8087.png";